export class RestoreJob {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobExecutionDetails",
            "baseName": "jobExecutionDetails",
            "type": "JobExecutionDetails",
            "format": ""
        },
        {
            "name": "resourceDetails",
            "baseName": "resourceDetails",
            "type": "ResourceDetails",
            "format": ""
        },
        {
            "name": "snapshotDetails",
            "baseName": "snapshotDetails",
            "type": "JobSnapshotDetails",
            "format": ""
        },
        {
            "name": "destinationDetails",
            "baseName": "destinationDetails",
            "type": "DestinationDetails",
            "format": ""
        },
        {
            "name": "partialRestoreData",
            "baseName": "partialRestoreData",
            "type": "PartialRestoreData",
            "format": ""
        },
        {
            "name": "vault",
            "baseName": "vault",
            "type": "BackupVault",
            "format": ""
        },
        {
            "name": "restoreType",
            "baseName": "restoreType",
            "type": "RestoreJobType",
            "format": ""
        },
        {
            "name": "configuration",
            "baseName": "configuration",
            "type": "RestoreJobConfiguration",
            "format": ""
        },
        {
            "name": "isGranular",
            "baseName": "isGranular",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "isInternal",
            "baseName": "isInternal",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "steps",
            "baseName": "steps",
            "type": "Array<JobStep>",
            "format": ""
        },
        {
            "name": "entraRestoreReport",
            "baseName": "entraRestoreReport",
            "type": "EntraRestoreJobReport",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreJob.attributeTypeMap;
    }
    constructor() {
    }
}
